import api from './api';

const state = {
	dutyExchanges: {},
	error: false,
	message: '',
	status: {},
	isDutyExchangesLoaded: false,
};

const getters = {};

const mutations = {
	setDutyExchanges(state, { dutyExchanges }) {
		state.dutyExchanges = dutyExchanges;
		state.isDutyExchangesLoaded = true;
	},
	setNewDutyExchange(state, { dutyExchange }) {
		state.dutyExchanges[dutyExchange.id] = dutyExchange;
	},
	setError(state, { message }) {
		(state.error = true), (state.message = message);
	},
	setStatus(state, { status }) {
		state.status = status;
	},
};

const actions = {
	async load({ state, commit, rootGetters, dispatch }, populate = false) {
		try {
			// dispatch('loadStatus');
			const dutyExchanges = (await api.getExchanges(populate)).data;
			commit('setDutyExchanges', { dutyExchanges });
			return dutyExchanges;
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},

	loadStatus({ commit }) {
		api.getStatus()
			.then((response) => {
				let status = response.data;
				commit('setStatus', { status });
			})
			.catch((err) => {
				console.log("Can't get status", err);
			});
	},
	async getDuty({ commit }, id) {
		try {
			const duty = (await api.getDuty(id)).data;
			return duty;
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},

	async approve({ state, commit, rootGetters }, id) {
		try {
			const duty = (await api.approve(id)).data;
			return duty;
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},

	async getExchangeTime({ commit }) {
		try {
			return await api.getExchangeTime();
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},

	async getExchangeTimeById({ commit }, id) {
		try {
			return await api.getExchangeTimeById(id);
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},

	async createExchangeTime({ commit }, body) {
		try {
			return await api.createExchangeTime(body);
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},

	async updateExchangeTime({ commit }, update) {
		try {
			return await api.updateExchangeTime(update);
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},
	async deleteExchangeTime({ commit }, id) {
		try {
			return await api.deleteExchangeTime(id);
		} catch (err) {
			commit('setError', { message: err.response.data.message });
			return null;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
